export default "__VITE_ASSET__Crr4Yy2i__"